import gsap from 'gsap';

export default class Lightbox {
  constructor({ data = [] } = {}) {
    this.data = data;
    this.currentIndex = 0;
    this.isOpen = false;

    this._build();
    this._bindEvents();
  }

  _build() {
    this.overlay = document.createElement('div');
    this.overlay.className = 'lightbox';
    this.overlay.innerHTML = `
      <button class="lightbox-close" type="button" aria-label="Fermer">&times;</button>
      <button class="lightbox-arrow lightbox-arrow--prev" type="button" aria-label="Image précédente">&#8592;</button>
      <div class="lightbox-stage">
        <img class="lightbox-image" src="" alt="" />
      </div>
      <button class="lightbox-arrow lightbox-arrow--next" type="button" aria-label="Image suivante">&#8594;</button>
    `;
    document.body.appendChild(this.overlay);

    this.stage = this.overlay.querySelector('.lightbox-stage');
    this.imageEl = this.overlay.querySelector('.lightbox-image');
    this.closeBtn = this.overlay.querySelector('.lightbox-close');
    this.prevBtn = this.overlay.querySelector('.lightbox-arrow--prev');
    this.nextBtn = this.overlay.querySelector('.lightbox-arrow--next');

    gsap.set(this.overlay, { autoAlpha: 0 });
  }

  _bindEvents() {
    // Écoute l'événement émis par GallerySlider au clic sur la vignette centrale
    document.addEventListener('gallery:open', (e) => {
      this.data = e.detail.data;
      this.open(e.detail.index);
    });

    this.closeBtn.addEventListener('click', () => this.close());
    this.prevBtn.addEventListener('click', () => this.show(this.currentIndex - 1));
    this.nextBtn.addEventListener('click', () => this.show(this.currentIndex + 1));

    this.overlay.addEventListener('click', (e) => {
      if (e.target === this.overlay || e.target === this.stage) this.close();
    });

    document.addEventListener('keydown', (e) => {
      if (!this.isOpen) return;
      if (e.key === 'Escape') this.close();
      if (e.key === 'ArrowLeft') this.show(this.currentIndex - 1);
      if (e.key === 'ArrowRight') this.show(this.currentIndex + 1);
    });
  }

  open(index) {
    this.isOpen = true;
    document.body.classList.add('lightbox-open');
    this.show(index, false);
    gsap.to(this.overlay, { autoAlpha: 1, duration: 0.35, ease: 'power2.out' });
  }

  show(index, animate = true) {
    const total = this.data.length;
    this.currentIndex = (index + total) % total;
    const item = this.data[this.currentIndex];
    if (!item) return;

    if (animate) {
      gsap.to(this.imageEl, {
        opacity: 0,
        duration: 0.18,
        onComplete: () => {
          this.imageEl.src = item.src;
          this.imageEl.alt = item.alt ?? '';
          gsap.to(this.imageEl, { opacity: 1, duration: 0.28 });
        }
      });
    } else {
      this.imageEl.src = item.src;
      this.imageEl.alt = item.alt ?? '';
    }
  }

  close() {
    this.isOpen = false;
    document.body.classList.remove('lightbox-open');
    gsap.to(this.overlay, { autoAlpha: 0, duration: 0.3, ease: 'power2.in' });
  }
}